import { Box, Table, TableBody, TableCell, TableRow } from "@mui/material";
import clsx from "clsx";
import CopytoclipboardIcon from "../CopytoclipboardIcon";
import { useStyles } from "./styles";
import { MemberListTableProps } from "./types";
import { MEMBER_LIST_FONT_SIZE } from "./utils";

function MemberListTable({ members = [] }: MemberListTableProps) {
  const classes = useStyles();

  if (!members.length) return null;

  return (
    <Box className={classes.listTable}>
      <Table size="small">
        <TableBody>
          {members.map((member, index) => (
            <TableRow key={member?.email || index}>
              <TableCell
                classes={{
                  root: clsx(
                    classes.listTableCell,
                    classes.listTableCellEmail
                  ),
                }}
              >
                {member?.email || "-"}
              </TableCell>
              <TableCell
                classes={{
                  root: clsx(
                    classes.listTableCell,
                    classes.listTableCellCopy
                  ),
                }}
              >
                {member?.email ? (
                  <CopytoclipboardIcon
                    item={member.email}
                    color="#64748B"
                    iconSize={MEMBER_LIST_FONT_SIZE}
                    className={classes.listTableCopyButton}
                  />
                ) : null}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Box>
  );
}

export { MemberListTable };
